<button  mat-flat-button [color]="color" class="{{ btnClass }} disabled:opacity-75 rounded" [type]="type"
    [disabled]="loading || formValid" [ngClass]="{ loading: loading }">
<mat-icon class="bx bx-loader bx-spin text-[16px] align-middle mr-2" [ngClass]="loading?'text-white opacity-100':''"
        *ngIf="loading">
    </mat-icon>
<span *ngIf="!loading" class="flex items-center justify-center text-custom">
    <ng-content></ng-content>
</span>
<span *ngIf="loading" [class.text-white]="loading">{{ loadingText }} </span>
</button>
